import React, { useEffect, useRef, useState } from 'react'
import * as htmlToImage from "html-to-image";
import { useNavigate, useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


import axios from "../axiosInstance";
import Sidebar from '../components/sidebar';
import Topbar from '../components/topbar';
import {errorMessage, postUserLog} from '../hooks/UserLogs';
import ConfirmModal from '../components/confirmModal';
export default function CustomerDetails() {
  const [agent, setAgent] = useState({});
  const [profile, setProfile] = useState("");
  const [newPin,setNewpin] = useState("");
  const [phone, setPhone]=useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [errMsg, setErrorMsg] = useState("Une erreure s'est produite!!");
  const [showError, setShowError] = useState(false);
  const [ListAgencies, setListAgencies] = useState([]);
  const [isAgenciesLoading, setIsAgenciesLoading] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [idCustomer, setIdCustomer] = useState('');
  const [idAgency, setIdAgency] = useState('');
  const [idAgent, setIdAgent] = useState("");
  const qrCodeRef = useRef(null);
  const inputFile = useRef(null);
  const { id } = useParams();
  const bUrl = process.env.REACT_APP_B_URL;

  const [showModalConfirmActive, setShowModalConfirmActive] = useState(false);
  const [showModalConfirmBlocked, setShowModalConfirmBlocked] = useState(false);
  const [showModalConfirmChangeAgency, setShowModalConfirmChangeAgency] = useState(false);

  const axiosInstance = axios.create({
                      withCredentials: true,
                    })
  
    const handleShowConfirmActive = (id, isActive) => {
        setShowModalConfirmActive(true);
        setIdCustomer(id);
        setIsActive(isActive);
    }
    const handleShowConfirmBlocked = (id, isBlocked) => {
      setShowModalConfirmBlocked(true);
      setIdCustomer(id);
      setIsBlocked(isBlocked);
    }

    const handleShowConfirmChangeAgency = (idAgency, id) => {
      if (!idAgency) return;
      setShowModalConfirmChangeAgency(true);
      setIdCustomer(id);
      setIdAgency(idAgency);
    }

  const handleCloseConfirmActive = () => setShowModalConfirmActive(false);
  const handleCloseConfirmBlocked = () => setShowModalConfirmBlocked(false);
  const handleCloseConfirmChangeAgency = () => setShowModalConfirmChangeAgency(false);

  const navigate = useNavigate();
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }
  const getAgent = async () => {
    const response = await axiosInstance.get(bUrl + "/customer-wallet/find-by-id?id=" + id).catch((err) => {
      //console.log(err);
      setIsLoading(false)

    });
    if (response) {
      if (response.status == 401) {
        navigate('/backoffice/login');
      }

      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        setErrorMsg(msg);
        setShowError(true);
      }else{
        setPhone(response.data.body.phone)
        setAgent(response.data.body);
      }

      setIsLoading(false);
      
    }
  }

  const handleCloseError = () => {
    setShowError(false);
  }

  const changePinByStaff=async ()=>{
    console.log(phone)
    console.log(sessionStorage.getItem("idUser"))
    const response = await axiosInstance.post(bUrl + "/customer-wallet/update-pin-by-staff",{
      "idStaff": sessionStorage.getItem("idUser"),
      "phoneNumber": phone,
      "phoneIdentity": "+224",
    }).catch((err) => {
      if (err?.response?.status == 401 || err?.response?.status == 403) {
        setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
        setShowError(true);
      } else {
        let msgErr = errMsg = + ' ' + err?.response?.status;
        setErrorMsg(msgErr);
        setShowError(true);
      }
      console.log(err);
      setIsLoading(false)
      });

      if (response) {
        if (response.status == 401) {
          navigate('/backoffice/login');
        }
        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          setErrorMsg(msg);
          setShowError(true);
        }else{
          console.log(response.data.body);
          setNewpin(response.data.body)
          await postUserLog(bUrl+"/userLogs/addUserLogs","PIN Change",phone);
        }
        

      }
      setIsLoading(false);


  }

  const activeOrDeactiveCustomer = async () => {

      const response = await axiosInstance.post(bUrl + "/customer-wallet/active-or-deactivate", {
        "idUser": idCustomer,
        "fkIdStaff": sessionStorage.getItem("idUser"),
      }).catch((err) => {
        if (err?.response?.status == 401 || err?.response?.status == 403) {
          setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
          setShowError(true);
        } else {
          let msgErr = errMsg = + ' ' + err?.response?.status;
          setErrorMsg(msgErr);
          setShowError(true);
        }
        console.log(err);
        setIsLoading(false)

      });
      if (response) {
        if (response.status == 401) {
          navigate('/backoffice/login');
        }
        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          setErrorMsg(msg);
          setShowError(true);
        }else{
          getAgent()
          await postUserLog(bUrl+"/userLogs/addUserLogs",(isActive)?'Activate':'Deactivate',response.data.body.phone);
        }

        setIsLoading(false);
        handleCloseConfirmActive()
        
      }
    
  }
  
  const blokeOrDeblokeCustomer = async () => {

      const response = await axiosInstance.post(bUrl + "/customer-wallet/block-or-deblock", {
        "fkIdStaff": sessionStorage.getItem("idUser"),
        "idUser": idCustomer
      }).catch((err) => {

        if (err?.response?.status == 401 || err?.response?.status == 403) {
          setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
          setShowError(true);
        } else {
          let msgErr = errMsg = + ' ' + err?.response?.status;
          setErrorMsg(msgErr);
          setShowError(true);
        }

        console.error(err);
        setIsLoading(false)

      });
      if (response) {
        if (response.status == 401) {
          navigate('/backoffice/login');
        }
        
        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          setErrorMsg(msg);
          setShowError(true);
        }else{
          getAgent()
          await postUserLog(bUrl+"/userLogs/addUserLogs",(isActive)?'Bloquer':'Debloquer',response.data.body.phone);

        }

        setIsLoading(false);
        handleCloseConfirmBlocked()
      }
    
  }

  const getListAgencies = async () => {
    setIsAgenciesLoading(true);
    const limit = 100;
    const getPage = (page) => axiosInstance.get(bUrl + "/agencies?page=" + page + "&limit=" + limit);

    const response = await getPage(1).catch((err) => {
      console.log(err);
      setIsAgenciesLoading(false);
      return null;
    });

    if (!response) return;

    if (response?.data?.isError) {
      const msg = errorMessage(response?.data?.code)
      setErrorMsg(msg);
      setShowError(true);
      setIsAgenciesLoading(false);
      return;
    }

    const totalPage = Number(response?.data?.totalPage) || 1;
    const agencies = [...(response?.data?.body || [])];
    if (totalPage > 1) {
      const pageResponses = [];
      try {
        for (let page = 2; page <= totalPage; page += 4) {
          const batch = await Promise.all(
            Array.from({ length: Math.min(4, totalPage - page + 1) }, (_, index) => getPage(page + index)),
          );
          pageResponses.push(...batch);
        }
      } catch (err) {
        console.log(err);
        setErrorMsg("Le chargement des agences a échoué.");
        setShowError(true);
        setIsAgenciesLoading(false);
        return;
      }
      pageResponses.forEach((pageResponse) => {
        agencies.push(...(pageResponse?.data?.body || []));
      });
    }

    setListAgencies(agencies);
    setIsAgenciesLoading(false);
  }

  const handleFileChange = (e) => {
    if (e.target.files) {
      setProfile(e.target.files[0]);
      const formData = new FormData();
      formData.append('formFile', e.target.files[0], id + '.jpg');
      //formData.append('fileName',idEmp+'.jpg');
      axios.post(bUrl + '/UploadFile', formData).then((res) => {
        console.log(res);
        //setView(false);
        setTimeout(() => {
          //viewShow(idEmp)
        }, 1000)

      }).catch((err) => {
        console.error(err);
      })
    }
  };

  const masterToAgency =async () => {
    if (!idAgency) {
      handleCloseConfirmChangeAgency();
      return;
    }

    setIdAgent(idAgency);
    
      const response = await axiosInstance.post(bUrl + "/customer-wallet/customer-wallet-to-agency", {
        "idAgency": idAgency,
        "idCustomerWallet": idCustomer,
        "idStaff": sessionStorage.getItem("idUser")
      }).catch((err) => {
        console.error(err);
        if (err?.response?.status == 401 || err?.response?.status == 403) {
          setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
          setShowError(true);
        } else {
          let msg = errMsg = + ' ' + err?.response?.status;
          setErrorMsg(msg);
          setShowError(true);
        }

        setIsLoading(false);

      });
      
      if (response) {
        if (response.status == 401) {
          navigate('/backoffice/login');
        }

        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          setErrorMsg(msg);
          setShowError(true);
        }else{
          getAgent()

          
        }
       
        setIsLoading(false);
        console.log(response?.data?.body)
        await postUserLog(bUrl + "/userLogs/addUserLogs", 'Agency change ', response?.data?.body?.phone);
        handleCloseConfirmChangeAgency();
      }
    
}

  const downloadQRCode = () => {
    htmlToImage.toPng(qrCodeRef.current).then(function (dataUrl) {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "qr-code.png";
      link.click();
    })
      .catch(function (error) {
        console.error("Error generating QR code:", error);
      });
  };
  useEffect(() => {
    if (sessionStorage.getItem("name") === '' || sessionStorage.getItem("name") === null) {
      //console.log("----------GO GO GO ------------")
      navigate('/backoffice/login');
    }
    getAgent();
    getListAgencies();
  }, []);
  
  return (
    <div>
      <Sidebar />
      <section className="home ">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-12">
            <div className="table-content mt-2 p-2 text d-flex justify-content-between">
              <div><p className='fw-bold'>{agent !== null ? agent.profile == 'CUSTOMER' ? 'Clients' : 'Marchand' : ""} &gt; Détails</p></div>
              <div><Topbar /></div>
            </div>
            {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
              <div className="table-content mt-3 p-3">
                <div className='row d-flex justify-content-center'>
                  {/* <div className='col-md-3'><input type="file" multiple ref={inputFile} hidden onChange={(e)=>handleFileChange(e)}/>
            <img src={agent.name} alt='img' className='w-100 im-upload' /> 
            </div> */}
            {agent?
            <>
                  <div className='col-md-3 bg-primary'>
                  </div>

                  <div className='col-md-6'>
                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Name:</div>
                      <div className='col-8 fw-bold'>{agent.firstName + " " + agent.middleName + " " + agent.lastName}</div>
                    </div>

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Pin Temporel:</div>
                      <div className='col-8 fw-bold'>{agent.pinTemp}</div>
                    </div>

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Téléphone:</div>
                      <div className='col-8 fw-bold'>{agent.phoneBrand}</div>
                    </div>

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Numéro Téléphone:</div>
                      <div className='col-8 fw-bold'>{agent.phone}
                      </div>
                    </div>

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Code:</div>
                      <div className='col-8 fw-bold'>{agent.code}
                      </div>
                    </div>

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Date Modification:</div>
                      <div className='col-8 fw-bold'>{formatDate(agent.updatedDate)}
                      </div>
                    </div>

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Date Création:</div>
                      <div className='col-8 fw-bold'>{formatDate(agent.createdDate)}
                      </div>
                    </div>

                    {agent.profile=="AGENT"?
                        <div className='row mb-2 row-details p-2'>
                        <div className='col-4'>Pourcentage d'achat:</div>
                        <div className='col-8 fw-bold'>
                          {agent.percentagePurchase +" % " } 
                          <a className='btn-link'>Changer</a>
                        </div>
                      </div>
                    :<></>}
                    
                    {agent.accounting !== null ?
                      <>
                        <div className='row mb-2 row-details p-2'>
                          <div className='col-4'>Solde:</div>
                          <div className='col-8 fw-bold'>{agent?.accounting?.balance} {agent?.accounting?.currency}</div>
                        </div>
                      </>
                      : ""}


                    {agent.staff !== null ?
                      <>
                        <div className='row mb-2 row-details p-2'>
                          <div className='col-4'>Modifié Par:</div>
                          <div className='col-8 fw-bold'>{agent?.staff?.firstName + ' ' + agent?.staff?.middleName + ' ' + agent?.staff?.lastName + " | " + agent?.staff?.login}</div>
                        </div>
                      </>
                      : ""}


                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Bloque:</div>
                      <div className='col-8 fw-bold'>
                        <label className="switch">
                          <input type="checkbox" className="i-btn" checked={agent.isBlocked ? 'checked' : ''} onChange={(e) => handleShowConfirmBlocked(agent.idCustomerWallet, e.target.checked)} />
                          <span className="slider-btn round"></span>
                        </label>
                      </div>
                    </div>
                  {sessionStorage.getItem('profile')=='SUPADMIN'?
                    <div className='row mb-2 row-details p-2'>
                    <div className='col-4'><span onClick={()=>changePinByStaff()}>Changer pin</span></div>
                    <div className='col-8 fw-bold'>
                      {newPin}
                      </div>
                      </div>
                  :""}
                    
                   

                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Active:</div>
                      <div className='col-8 fw-bold'>
                        <label className="switch">
                          <input type="checkbox" className="i-btn" checked={agent.isActive ? 'checked' : ''} onChange={(e) => handleShowConfirmActive(agent.idCustomerWallet, e.target.checked)} />
                          <span className="slider-btn round"></span>
                        </label>
                      </div>
                    </div>
                  {agent.profile === 'AGENT'?
                    <div className='row mb-2 row-details p-2'>
                      <div className='col-4'>Agence:</div>
                      <div className='col-8 fw-bold'>
                        <div className="form-group text">
                          <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" value={agent.fkIdAgency != null ? agent.fkIdAgency : idAgent} disabled={isAgenciesLoading} onChange={(e) => handleShowConfirmChangeAgency(e.target.value,agent.idCustomerWallet)}>
                            {isAgenciesLoading ?
                              <option value={agent.fkIdAgency != null ? agent.fkIdAgency : idAgent}>Chargement des agences...</option>
                              : <option value="" disabled>Sélectionnez une Agence</option>}
                            {ListAgencies != null ? ListAgencies.length > 0 ? ListAgencies.map((a, i) => {
                              return <option value={a.idAgency} key={i}>{a.name + " | " + a.code}</option>
                            }
                            ) : '' : ''}
                          </select>

                        </div>
                      </div>
                    </div>
                  :<> </>}
                  </div>
                  </>
                  :<></>}
                  <div className='qr-containe col-md-3' ref={qrCodeRef} >
                    {/* <QRCode
              size={256}
              id="123456"
              style={{ height: "auto", maxWidth: "100%", width: "90%" }}
              value={agent.code}
              fgColor="#005f99"
              bgColor="#fff"
              viewBox={`0 0 256 256`}/>
              <div onClick={downloadQRCode} style={{textAlign:'center',cursor:'pointer'}}>Download QR Code</div> */}
                  </div>
                </div>
              </div>
            }
          </div>
          <Modal show={showError} onHide={handleCloseError} className="">
                    <Modal.Header closeButton className="bg-danger">
                      <Modal.Title>ERROR</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleCloseError}>
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
          <ConfirmModal
                show={showModalConfirmActive}
                handleClose={handleCloseConfirmActive}
                handleConfirm={activeOrDeactiveCustomer}
            />

            <ConfirmModal
                show={showModalConfirmBlocked}
                handleClose={handleCloseConfirmBlocked}
                handleConfirm={blokeOrDeblokeCustomer}
            />

<ConfirmModal
                show={showModalConfirmChangeAgency}
                handleClose={handleCloseConfirmChangeAgency}
                handleConfirm={masterToAgency}
            />
        </div>
      </section>
    </div>
  )
}
